var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSorgeniaGeneral(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 65 65",
    xmlns: "http://www.w3.org/2000/svg",
    transform: "translate(2 0)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_112_3345)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.5288 35.858V53.389H30.6418C31.6638 47.925 36.8838 36.996 63.2138 35.972V35.858H30.5288Z",
    fill: "#90D400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5862 32.557C33.7062 31.532 21.6762 26.524 20.3142 0H20.2012V32.671H38.5862V32.557Z",
    fill: "#90D400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.024 25.158H16.91C16.343 29.711 13.619 41.436 0 43.599V43.941H17.024V25.158Z",
    fill: "#90D400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.96484 47.242C13.8448 47.925 25.3078 50.998 27.1228 65H27.2358V47.014H8.96484V47.242Z",
    fill: "#90D400"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_112_3345"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 65
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSorgeniaGeneral);
export default __webpack_public_path__ + "static/media/Sorgenia_general.afd3f0ea858cae9c6a0c58a5e92bc928.svg";
export { ForwardRef as ReactComponent };